import React from 'react';
import { Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// Add CSS animation
const style = document.createElement('style');
style.textContent = `
  @keyframes gridPan {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 40px 40px;
    }
  }
`;
document.head.appendChild(style);

const LoadingScreen = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-dark)',
      zIndex: 9999
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `linear-gradient(rgba(44, 95, 138, 0.15) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(44, 95, 138, 0.15) 1px, transparent 1px)`,
        backgroundSize: '40px 40px',
        animation: 'gridPan 20s linear infinite',
        opacity: 0.4,
        pointerEvents: 'none'
      }} />
      <div style={{
        textAlign: 'center',
        color: 'white'
      }}>
        <div style={{
          fontSize: '48px',
          fontWeight: 'bold',
          marginBottom: '24px',
          letterSpacing: '2px'
        }}>
          Civily
        </div>
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 48, color: 'white' }} spin />}
          size="large"
        />
        <div style={{
          marginTop: '24px',
          fontSize: '16px',
          opacity: 0.9
        }}>
          Loading your workspace...
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
